import { useGetTableValueQuery } from "../../../../../api/rtk/base/slices/tablesApiSlice"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

export default function RoadAccidentSegmentsOverlay() {
    const yearFilter = useAppSelector(state => state.roadAccidentSegments.roadAccidentSegmentsMapYearFilter)
    const { data: roadAccidentSegments, isFetching: roadAccidentSegmentsIsFetching, isError: roadAccidentSegmentsIsError } = useGetTableValueQuery(
        {
            tableValueUrl: 'objects/RoadAccidentSegments',
            pages: true,
            top: 0,
            filterStringArray: [`Year eq ${yearFilter}`]
        }
    )

    return (
        <div className="map-overlay-highway-network-segment map-overlay">
            <div className="map-overlay-info-block">
                <span className="info-hint-label-field">Всего участков концентрации ДТП:</span>
                {roadAccidentSegmentsIsFetching
                    ?
                    <div>
                        <span className="spinner-border spinner-border-sm me-2 ms-2" role="status" aria-hidden="true"></span>
                        <span>Загрузка...</span>
                    </div>
                    :
                    <>
                        {roadAccidentSegmentsIsError
                            ?
                            <span className="info-hint-label-value">Ошибка</span>
                            :
                            <span className="info-hint-label-value">{roadAccidentSegments['@xdata.count']}</span>
                        }
                    </>
                }
            </div>
        </div>
    )
}
